const SVG_MARKER_CIRCLE_MAP: Record<string, string> = {};
const generateSvgMarkerCircle = (color: string): string => {
  const svg = `
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="6" fill="white" stroke="${color || '#888'}" stroke-width="4"/>
  </svg>
`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

// EXPORT
export const getSVGMarkerCircle = (color: string): string => {
  if (!SVG_MARKER_CIRCLE_MAP[color]) {
    SVG_MARKER_CIRCLE_MAP[color] = generateSvgMarkerCircle(color);
  }
  return SVG_MARKER_CIRCLE_MAP[color];
}
